import { useForm } from "react-hook-form";
import Layout from "../../components/layouts/layout.comp";
import { useTranslation } from "../../core/translation.core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { GiftCardDefFormData } from "../../types/giftCard";
import giftCardCore from "../../core/giftCard.core";
import GiftCardDefEditor from "../../components/giftCard/giftCardDefEditor";
import { EditingMode } from "../../components/reuseables/form.comp";

export default function GiftCardDefCreatePage() {
  const { t, msg } = useTranslation();
  const queryClient = useQueryClient();
  const router = useRouter();

  const methods = useForm<GiftCardDefFormData>({
    defaultValues: {
      issueMode: "manual",
      rewardPayout: 0,
      validityPeriod: 365,
    },
  });

  const mutation = useMutation({
    mutationFn: async (data: GiftCardDefFormData) => {
      await giftCardCore.create(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["giftCards"] });
      router.push("/giftCard/defList");
    },
  });

  return (
    <Layout title={t(msg.giftCard.create)}>
      <GiftCardDefEditor methods={methods} btnText={t(msg.form.create)} mutation={mutation} editingMode={EditingMode.create} />
    </Layout>
  );
}
